var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.71 4.04a.65.65 0 0 1 0 .92L6.668 8l3.04 3.04a.65.65 0 1 1-.919.92l-3.5-3.5a.65.65 0 0 1 0-.92l3.5-3.5a.65.65 0 0 1 .92 0Z","fill":"currentColor"}));
}

ChevronLeft.defaultProps = {"width":"16","height":"16","fill":"none"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
